import React from 'react'

// VISUALS
import {
    depthFrontOfPlateInches,
    depthMidPlateInches,
} from 'bam-node-baseball-savant/constants/zone.ts'
import Pitches from './Pitches.tsx'
import Zone from './Zone.tsx'
import HexBin from './HexBin.tsx'
import Contour from './Contour.tsx'
import PitchPie from './Pie.tsx'
// The below (Axis) uses a data type that isn't like Gamefeed or Illustrator data types.
// Therefore I'm not going to bother TS'ing it (yet)
// @ts-expect-error - TODO: Convert to TypeScript
import Axis from './Spin/Axis'

/// VISUAL HELPERS
import HomePlate from '../Helpers/HomePlate.tsx'
import StrikeZone from '../Helpers/StrikeZone.tsx'
import RightHandedBatter from '../Helpers/RightHandedBatter.tsx'
import LeftHandedBatter from '../Helpers/LeftHandedBatter.tsx'

import { ChartOptions, EVPData, Settings } from '../../schema/types.ts'
import StrikeZoneBackground from '../Helpers/StrikeZoneBackground.tsx'

type PitchTypeProps = {
    chartOptions: ChartOptions
    settings: Settings
    onPitchClick: (event: React.MouseEvent, pitch: EVPData) => void
}

export default function PitchType({
    chartOptions,
    settings,
    onPitchClick,
}: PitchTypeProps) {
    const { pitcherPerspective } = chartOptions
    const { data } = settings

    // Memoize perhaps
    const hasFrontPlate = Boolean(
        data.find((d) => d.szDepth === depthFrontOfPlateInches)
    )
    const hasMidPlate = Boolean(
        data.find((d) => d.szDepth === depthMidPlateInches)
    )

    return (
        <>
            {chartOptions.showRHB ? (
                <RightHandedBatter pitcherPerspective={pitcherPerspective} />
            ) : null}
            {chartOptions.showLHB ? (
                <LeftHandedBatter pitcherPerspective={pitcherPerspective} />
            ) : null}
            {chartOptions.showPlate ? (
                <HomePlate
                    pitcherPerspective={pitcherPerspective}
                    showFrontPlateShadow={hasFrontPlate}
                    showMidPlateShadow={hasMidPlate}
                />
            ) : null}

            {chartOptions.showStrikeZone ? <StrikeZoneBackground /> : null}

            {chartOptions.overlayType === 'pie' && data.length > 0 ? (
                <PitchPie />
            ) : null}

            {chartOptions.overlayType === 'pitch' ? (
                <Pitches onPitchClick={onPitchClick} />
            ) : null}

            {chartOptions.overlayType === 'zone' ? (
                <Zone settings={settings} chartOptions={chartOptions} />
            ) : null}

            {chartOptions.overlayType === 'contour' && data.length > 0 ? (
                <Contour />
            ) : null}
            {chartOptions.overlayType === 'hexbin' && data.length > 0 ? (
                <HexBin />
            ) : null}
            {chartOptions.overlayType === 'spinAxis' && data.length > 0 ? (
                <Axis settings={settings} chartOptions={chartOptions} />
            ) : null}

            {/* TODO: Consider the correct "z-index" for this */}
            {chartOptions.showStrikeZone ? <StrikeZone /> : null}
        </>
    )
}
